/**
 * useTrialCardGate — live wiring for the card step (docs/PLAN-trial-card-on-file-20261020.md): does the person in
 * this tab's workspace need to add the trial's card before they can work? The rule is the pure needsTrialCard
 * (./trialOnboardingGate.ts); this hook only feeds it what the trial banner and the billing banners already read — the
 * workspace's trial (useWorkspaceTrialStatus: the person's own subscription document, or an organization's member
 * mirror) and whether they may manage its billing (useUsageVisibility). Loading until both have been read, so the
 * router never redirects on a half-read state.
 */
import { useWorkspaceTrialStatus } from './useTrialStatus';
import { useUsageVisibility } from './useUsageVisibility';
import { needsTrialCard } from './trialOnboardingGate';

export interface TrialCardGateState {
  loading: boolean;
  needsCard: boolean;
}

export function useTrialCardGate(): TrialCardGateState {
  const trial = useWorkspaceTrialStatus();
  const vis = useUsageVisibility();
  const loading = trial.isLoading || vis.loading;
  return {
    loading,
    needsCard: needsTrialCard({
      conversion: trial.conversion,
      trialReady: !trial.isLoading,
      permissionReady: !vis.loading,
      canManageBilling: vis.canManageBilling,
    }),
  };
}
